<template>
	<div class="card" :class="[card.value ? 'card-value-' + card.value : '', 'card-' + card.type]">
		<span v-if="card.value" class="card-value">{{ card.value }}</span>
		<span v-if="card.icon" class="card-illustration">
			<icon class="bg-icon" :file="card.icon" :size="56" />
			<icon class="main-icon" :file="card.icon" :size="56" />
		</span>
		<span v-if="card.type == 'logo'" class="card-value">+</span>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Card',
	data () {
		return {
			
		}
	},
	props: [ 'card' ],
	computed: Object.assign(mapGetters([ 'lang' ]), {
		
	})
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.card
	display inline-block
	width card_width
	height card_height
	background-color lightblue
	text-shadow 2px 2px 0px darken(lightblue, 20%)
	box-shadow inset 0 -4px darken(lightblue, 25%)
	border-radius 8px
	overflow hidden
	display flex
	align-items center
	justify-content center
	font-size 32px
	color #fff
	&.card-value-1
		background-color blue
		text-shadow 2px 2px 0px darken(blue, 20%)
		box-shadow inset 0 -4px darken(blue, 25%)
	&.card-value-2
		background-color teal
		text-shadow 2px 2px 0px darken(teal, 20%)
		box-shadow inset 0 -4px darken(teal, 25%)
	&.card-value-3
		background-color green
		text-shadow 2px 2px 0px darken(green, 20%)
		box-shadow inset 0 -4px darken(green, 25%)
	&.card-value-4
		background-color yellow
		text-shadow 2px 2px 0px darken(yellow, 20%)
		box-shadow inset 0 -4px darken(yellow, 25%)
	&.card-value-5
		background-color orange
		text-shadow 2px 2px 0px darken(orange, 20%)
		box-shadow inset 0 -4px darken(orange, 25%)
	&.card-value-6
		background-color red
		text-shadow 2px 2px 0px darken(red, 20%)
		box-shadow inset 0 -4px darken(red, 25%)
	&.card-value-7
		background-color pink
		text-shadow 2px 2px 0px darken(pink, 20%)
		box-shadow inset 0 -4px darken(pink, 25%)
	&.card-value-8
		background-color purple
		text-shadow 2px 2px 0px darken(purple, 20%)
		box-shadow inset 0 -4px darken(purple, 25%)
	&.card-value-9
		background-color gray
		text-shadow 2px 2px 0px darken(gray, 20%)
		box-shadow inset 0 -4px darken(gray, 25%)
	&.card-logo
		// width card_height
		.card-value
			font-size 64px
	&:before
		content ''
		position absolute
		left 50%
		top 0
		right 0
		bottom 0
		background alpha(#000, 5%)
	.card-illustration
		.main-icon, .bg-icon
			display block
			position absolute
			left 50%
			top 50%
			transform translate3D(-50%, -50%, 0)
		.bg-icon
			color darken(lightblue, 10%)
			transform translate3D(-46%, -46%, 0)
</style>



// WEBPACK FOOTER //
// src/components/game/Card.vue